import type { GetApiV1RefundsEligibilityOrderId200AllOfThreeData } from './getApiV1RefundsEligibilityOrderId200AllOfThreeData';

export type GetApiV1RefundsEligibilityOrderId200AllOfThree = {
  data?: GetApiV1RefundsEligibilityOrderId200AllOfThreeData;
};
